import styled, { css, keyframes } from 'styled-components';

export const CheckoutPageContainer = styled.div`
  min-height: 100vh;
  background-color: oklch(0.9842 0.0034 247.86);
  direction: rtl;
  padding: 24px;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const CheckoutWrapper = styled.div`
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
`;

// Header
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  color: oklch(55.44% 0.041 257.42);
  font-family: inherit;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  padding: 8px 0;
  transition: color 0.2s;

  &:hover {
    color: oklch(0.2077 0.0398 265.75);
  }
`;

export const HeaderTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  svg {
    color: oklch(0.65 0.24 33.09);
  }
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 700;
  color: oklch(0.2077 0.0398 265.75);
  margin: 0;
`;

// Layout
export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media (min-width: 1024px) {
    grid-template-columns: 380px 1fr;
    align-items: start;
  }
  
  @media (max-width: 768px) {
    gap: 24px;
  }
`;

export const LeftColumn = styled.div``;
export const RightColumn = styled.div``;

// Summary Card
export const SummaryCard = styled.div`
  background: oklch(1 0 0);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  position: sticky;
  top: 24px;

  @media (max-width: 768px) {
    position: static;
    margin-bottom: 0;
    padding: 20px;
  }
`;

export const SummaryHeader = styled.div`
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid oklch(0.9683 0.0069 247.9);
`;

export const SummaryTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  color: oklch(0.2077 0.0398 265.75);
`;

export const ProductSection = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  align-items: flex-start;
`;

export const ProductImageWrapper = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid oklch(0.9683 0.0069 247.9);
  flex-shrink: 0;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ProductInfo = styled.div`
  flex: 1;
`;

export const ProductTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: oklch(0.2077 0.0398 265.75);
  margin: 0 0 8px 0;
  line-height: 1.4;
`;

export const QuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1px;
  margin-bottom: 4px;
`;

export const ProductQuantity = styled.span`
  font-size: 12px;
  color: oklch(55.44% 0.041 257.42);
  background: oklch(0.9842 0.0034 247.86);
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-block;
  font-weight: 500;
`;

export const EditButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: oklch(0.65 0.24 33.09);
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: oklch(0.6 0.23 33.01);
    text-decoration: underline;
  }
`;

export const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  align-self: flex-start;
`;

export const QuantityButton = styled.button`
  background: oklch(0.9842 0.0034 247.86);
  border: 1px solid oklch(0.9288 0.0126 255.51);
  cursor: pointer;
  color: oklch(0.2077 0.0398 265.75);
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  width: 28px;
  height: 28px;

  &:hover {
    background-color: oklch(0.9683 0.0069 247.9);
    border-color: oklch(0.869 0.0198 252.89);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const QuantityValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: oklch(0.2077 0.0398 265.75);
  min-width: 24px;
  text-align: center;
`;

export const CancelEditButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: oklch(0.61 0.25 28.5);
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  margin-right: 4px;

  &:hover {
    background-color: oklch(0.9356 0.0309 17.72);
  }
`;

export const RemoveButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: oklch(0.61 0.25 28.5);
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  flex-shrink: 0;
  align-self: flex-start;

  &:hover {
    background-color: oklch(0.9356 0.0309 17.72);
  }
`;

export const Divider = styled.div`
  display: none;
`;

export const SummaryDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

export const SummaryLabel = styled.span`
  color: oklch(55.44% 0.041 257.42);
`;

export const SummaryValue = styled.span`
  font-weight: 600;
  color: oklch(0.2077 0.0398 265.75);
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const FreeShippingText = styled.span`
  color: oklch(69.59% 0.149 162.48);
  font-weight: 600;
`;

export const FreeShippingHint = styled.div`
  font-size: 13px;
  color: oklch(0.65 0.24 33.09);
  font-weight: 500;
  padding: 8px 12px;
  background: oklch(0.65 0.24 33.09 / 0.08);
  border-radius: 8px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed oklch(0.9288 0.0126 255.51);
`;

export const TotalLabel = styled.span`
  font-weight: 700;
  color: oklch(0.2077 0.0398 265.75);
  font-size: 16px;
`;

export const TotalValue = styled.span`
  font-weight: 800;
  color: oklch(0.65 0.24 33.09);
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const RiyalIcon = styled.span`
  width: 14px;
  height: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const CouponSection = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px dashed oklch(0.9288 0.0126 255.51);
`;

export const CouponWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

export const CouponInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  color: oklch(0.2077 0.0398 265.75);
  background: oklch(1 0 0);
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: oklch(0.65 0.24 33.09);
    box-shadow: 0 0 0 3px oklch(0.65 0.24 33.09 / 0.1);
  }

  &::placeholder {
    color: oklch(0.7107 0.0351 256.79);
  }
`;

export const ApplyCouponButton = styled.button`
  padding: 12px 20px;
  background: oklch(0.65 0.24 33.09);
  color: oklch(1 0 0);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: oklch(0.6 0.23 33.01);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    background: oklch(0.869 0.0198 252.89);
    cursor: not-allowed;
  }
`;

export const AppliedCouponInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
`;

export const CheckIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: oklch(69.59% 0.149 162.48);
  border-radius: 50%;
  flex-shrink: 0;
`;

export const CouponCodeText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: oklch(0.2077 0.0398 265.75);
  font-weight: 600;
  background: oklch(0.9683 0.0069 247.9);
  border: 1px solid oklch(0.9288 0.0126 255.51);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 13px;
  margin-right: 8px;
`;

export const RemoveCouponButton = styled.button`
  background: transparent;
  border: none;
  color: oklch(55.44% 0.041 257.42);
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  font-family: inherit;
  text-decoration: underline;

  &:hover {
    color: oklch(0.2077 0.0398 265.75);
  }
`;

export const DiscountRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: oklch(69.59% 0.149 162.48);
  font-weight: 600;
  margin-top: 8px;
`;

// Payment Card
export const PaymentCard = styled.div`
  background: oklch(1 0 0);
  border-radius: 16px;
  padding: 32px;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  box-shadow: 0 2px 4px -1px oklch(0 0 0 / 0.03);

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const PaymentHeader = styled.div`
  margin-bottom: 32px;
`;

export const Steps = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: oklch(0.9683 0.0069 247.9);
  color: oklch(55.44% 0.041 257.42);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  transition: all 0.3s;
`;

export const StepTitle = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: oklch(0.2077 0.0398 265.75);
`;

interface StepProps {
  $active?: boolean;
  $completed?: boolean;
}

export const Step = styled.div<StepProps>`
  display: flex;
  align-items: center;
  gap: 12px;
  opacity: 0.5;
  transition: all 0.3s;
  
  ${props => props.$active && css`
    opacity: 1;
    
    ${StepNumber} {
      background: oklch(0.65 0.24 33.09);
      color: oklch(1 0 0);
      box-shadow: 0 0 0 4px oklch(0.65 0.24 33.09 / 0.1);
    }
  `}

  ${props => props.$completed && css`
    opacity: 1;
    cursor: pointer;

    ${StepNumber} {
      background: oklch(69.59% 0.149 162.48);
      color: oklch(1 0 0);
    }

    ${StepTitle} {
      color: oklch(69.59% 0.149 162.48);
    }
  `}
`;

export const StepDivider = styled.div<{ $active?: boolean }>`
  flex: 1;
  height: 2px;
  background: oklch(0.9683 0.0069 247.9);
  margin: 0 24px;
  border-radius: 2px;

  ${props => props.$active && css`
    background: oklch(69.59% 0.149 162.48);
  `}

  @media (max-width: 768px) {
    margin: 0 12px;
  }
`;

export const PaymentSubtitle = styled.p`
  color: oklch(55.44% 0.041 257.42);
  margin: 0;
  font-size: 14px;
`;

// Form
// ✅ تم تغييره من div إلى form لتمكين Yandex Metrika Form Analysis
export const CustomerForm = styled.form`
  max-width: 100%;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const FormLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 14px;
  color: oklch(0.3717 0.0392 257.29);
`;

export const TooltipContent = styled.div`
  visibility: hidden;
  width: 240px;
  background-color: oklch(0.2077 0.0398 265.75);
  color: oklch(1 0 0);
  text-align: center;
  border-radius: 8px;
  padding: 10px;
  position: absolute;
  z-index: 10;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  opacity: 0;
  transition: opacity 0.2s;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 4px 6px -1px oklch(0 0 0 / 0.1);
  border: 1px solid oklch(0.2077 0.0398 265.75);
  pointer-events: none;
  line-height: 1.4;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: oklch(0.2077 0.0398 265.75) transparent transparent transparent;
  }
  
  &::before {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -7px;
    border-width: 7px;
    border-style: solid;
    border-color: oklch(0.2077 0.0398 265.75) transparent transparent transparent;
  }
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
  vertical-align: middle;
`;

export const TooltipIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: oklch(0.3717 0.0392 257.29);
  cursor: help;
  
  &:hover {
    color: oklch(0.2077 0.0398 265.75);
  }

  &:hover + ${TooltipContent} {
    visibility: visible;
    opacity: 1;
  }
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  max-width: 100%;
  padding: 14px 16px;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  border-radius: 12px;
  font-family: inherit;
  font-size: 15px;
  color: oklch(0.2077 0.0398 265.75);
  background: oklch(1 0 0);
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: oklch(0.65 0.24 33.09);
    box-shadow: 0 0 0 4px oklch(0.65 0.24 33.09 / 0.1);
  }

  ${props => props.$hasError && css`
    border-color: oklch(0.61 0.25 28.5);
    background-color: oklch(0.9705 0.0129 17.38);
  `}
`;

export const PhoneInput = styled(Input)`
  direction: ltr;
  text-align: right;
`;

export const Select = styled.select<{ $hasError?: boolean }>`
  width: 100%;
  max-width: 100%;
  padding: 14px 16px;
  padding-left: 40px;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  border-radius: 12px;
  font-family: inherit;
  font-size: 15px;
  color: oklch(0.2077 0.0398 265.75);
  background-color: oklch(1 0 0);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: left 12px center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  box-sizing: border-box;
  transition: all 0.2s;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: oklch(0.65 0.24 33.09);
    box-shadow: 0 0 0 4px oklch(0.65 0.24 33.09 / 0.1);
  }

  ${props => props.$hasError && css`
    border-color: oklch(0.61 0.25 28.5);
    background-color: oklch(0.9705 0.0129 17.38);
  `}
`;

export const ErrorMessage = styled.p`
  color: oklch(0.61 0.25 28.5);
  font-size: 12px;
  margin-top: 6px;
`;

export const HelperText = styled.div`
  background-color: oklch(0.9683 0.0069 247.9);
  color: oklch(55.44% 0.041 257.42);
  font-size: 12px;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 400;
  line-height: 1.5;
`;

export const SectionSubtitle = styled.h3`
  margin: 32px 0 20px;
  font-size: 16px;
  font-weight: 700;
  color: oklch(0.2077 0.0398 265.75);
`;

export const PaymentSectionWrapper = styled.div`
  border-radius: 12px;
  padding: 24px;
  margin-top: 24px;
  border: 1px solid oklch(0.9288 0.0126 255.51);
`;

// Payment Options
export const PaymentOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RadioCircle = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid oklch(0.869 0.0198 252.89);
  border-radius: 50%;
  margin-left: 16px;
  position: relative;
  transition: all 0.2s;
  flex-shrink: 0;
`;

export const PaymentOption = styled.div<{ $isSelected?: boolean }>`
  border: 1px solid oklch(0.9288 0.0126 255.51);
  border-radius: 12px;
  background: oklch(1 0 0);
  overflow: hidden;
  transition: all 0.2s;

  &:hover {
    border-color: oklch(0.869 0.0198 252.89);
  }

  ${props => props.$isSelected && css`
    border-color: oklch(0.65 0.24 33.09);
    background: oklch(1 0 0);
    box-shadow: 0 0 0 1px oklch(0.65 0.24 33.09);

    ${RadioCircle} {
      border-color: oklch(0.65 0.24 33.09);
      background: oklch(0.65 0.24 33.09);

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        background: oklch(1 0 0);
        border-radius: 50%;
      }
    }
  `}
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  padding: 20px;
  cursor: pointer;
  width: 100%;
  position: relative;

  input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
  }
`;

export const OptionContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const OptionText = styled.span`
  font-weight: 600;
  font-size: 15px;
  color: oklch(0.2077 0.0398 265.75);
`;

export const OptionLogo = styled.img`
  height: 24px;
  object-fit: contain;
`;

export const OptionForm = styled.div`
  padding: 0 20px 24px;
  border-top: 1px dashed oklch(0.9288 0.0126 255.51);
  margin-top: 0;
  padding-top: 24px;
`;

export const FormWrapper = styled.div`
  max-width: 100%;

  /* Tap Card Overrides */
  .tap-form-wrapper {
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
  }

  #tap-card-element {
    border-radius: 12px !important;
    border-color: oklch(0.9288 0.0126 255.51) !important;
  }
`;

export const PayButton = styled.button`
  width: 100%;
  padding: 16px;
  background: oklch(0.65 0.24 33.09);
  color: oklch(1 0 0);
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
  margin-top: 24px;

  &:hover:not(:disabled) {
    background: oklch(0.6 0.23 33.01);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background: oklch(0.869 0.0198 252.89);
    cursor: not-allowed;
  }
`;

export const FormBackButton = styled.button`
  background: transparent;
  border: none;
  color: oklch(0.65 0.24 33.09);
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  padding: 12px;
  margin-top: 16px;
  width: 100%;
  font-size: 14px;

  &:hover {
    background: oklch(0.9705 0.0129 17.38);
    border-radius: 8px;
  }
`;

// Result Modal
export const ResultOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: oklch(0.2077 0.0398 265.75 / 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  padding: 20px;
`;

export const ResultModal = styled.div`
  background: oklch(1 0 0);
  padding: 32px;
  border-radius: 20px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 20px 25px -5px oklch(0 0 0 / 0.1);

  h3 {
    margin: 0 0 24px;
    font-size: 18px;
    color: oklch(0.2077 0.0398 265.75);
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
`;

export const CloseButton = styled.button`
  padding: 12px 32px;
  background: oklch(0.9683 0.0069 247.9);
  color: oklch(0.2077 0.0398 265.75);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;
  flex: 1;

  &:hover {
    background: oklch(0.9288 0.0126 255.51);
  }
`;

export const ConfirmDeleteButton = styled(CloseButton)`
  background: oklch(0.9356 0.0309 17.72);
  color: oklch(0.61 0.25 28.5);

  &:hover {
    background: oklch(0.8845 0.0593 18.33);
  }
`;

// ─── Busy Modal (المتجر مشغول) ────────────────────────────────────────────────
export const BusyModal = styled.div`
  background: oklch(1 0 0);
  padding: 36px 28px 28px;
  border-radius: 22px;
  width: 100%;
  max-width: 360px;
  text-align: center;
  box-shadow: 0 24px 48px -12px oklch(0.2077 0.0398 265.75 / 0.22);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/* وميض كهرماني نابض ينبعث من خلف الأيقونة */
const busyPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 oklch(0.751 0.16 72 / 0.55);
  }
  70% {
    box-shadow: 0 0 0 18px oklch(0.751 0.16 72 / 0);
  }
  100% {
    box-shadow: 0 0 0 0 oklch(0.751 0.16 72 / 0);
  }
`;

export const BusyIconBadge = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: oklch(0.951 0.055 83);
  color: oklch(0.705 0.165 62);
  margin-bottom: 22px;
  animation: ${busyPulse} 1.8s ease-out infinite;

  /* تعطيل الحركة لمن يفضّل تقليل الحركة، مع إبقاء حلقة ثابتة خفيفة */
  @media (prefers-reduced-motion: reduce) {
    animation: none;
    box-shadow: 0 0 0 8px oklch(0.951 0.055 83 / 0.5);
  }
`;

export const BusyTitle = styled.h3`
  margin: 0 0 10px;
  font-size: 19px;
  font-weight: 700;
  color: oklch(0.2077 0.0398 265.75);
`;

export const BusyText = styled.p`
  margin: 0 0 26px;
  font-size: 14.5px;
  line-height: 1.75;
  color: oklch(0.5544 0.041 257.42);
  max-width: 290px;
`;

export const BusyButton = styled.button`
  width: 100%;
  padding: 14px;
  background: oklch(0.65 0.24 33.09);
  color: oklch(1 0 0);
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;

  &:hover {
    background: oklch(0.6 0.23 33.01);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const EmptyCartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  background: oklch(1 0 0);
  border-radius: 16px;
  border: 1px solid oklch(0.9288 0.0126 255.51);
  min-height: 400px;
  margin-top: 20px;
`;

export const EmptyCartText = styled.p`
  font-size: 18px;
  color: oklch(55.44% 0.041 257.42);
  margin: 16px 0 24px;
  font-weight: 500;
`;

export const EmptyCartIcon = styled.div`
  color: oklch(0.869 0.0198 252.89);
  margin-bottom: 16px;
`;
